<template>
  <div ref="target" class="news-list">
    <div class="left">
      <div class="top">
        <div class="top-carousel">
          <NewsCarousel :bannerList="bannerList" />
          <DomainList :domainList="domainList" />
        </div>
      </div>
      <div class="bottom">
        <NewsVideo :list="list" />
      </div>
    </div>
    <div class="middle">
      <PolicyNews :policyList="policyList" :domainList="domainList" />
    </div>
    <div class="right">
      <NoticeNews :noticeList="noticeList" :domainList="domainList" />
      <div class="notes">
        <NewsTests :testList="testList" />
      </div>
    </div>
  </div>
</template>

<script>
import DomainList from "../common/domain-list.vue";
import NewsVideo from "../newsvideo/news-video";
import NewsTests from "../newstests/news-tests";
import NewsCarousel from "../common/new-carousel";
import PolicyNews from "../common/policy-news.vue";
import NoticeNews from "../common/notice-news.vue";
import { findNewsVideo, findNewsTests } from "@/api/news";
import { useLazyData, useLazyNewsTests } from "@/hooks/index";
import { computed, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    NewsVideo,
    NewsTests,
    NewsCarousel,
    DomainList,
    PolicyNews,
    NoticeNews,
  },
  props: {
    policyList: {
      type: Object,
      default: () => {},
    },
    noticeList: {
      type: Object,
      default: () => {},
    },
    bannerList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const store = useStore();
    const clID = ref();
    const target = ref(null);
    let intervalId = null;
    let gaojizhongyi = [
      1733, 1737, 1841, 2871, 1842, 2872, 1740, 1726, 1734, 1729, 1840, 2870,
      3570, 3574, 3571, 2873, 1844,
    ];

    function getRandomNumber(arr) {
      const randomIndex = Math.floor(Math.random() * arr.length);
      return arr[randomIndex];
    }

    intervalId = setInterval(() => {
      clID.value = getRandomNumber(gaojizhongyi);
    }, 3000);
    const { result } = useLazyData(target, () =>
      findNewsVideo({ clID: [clID.value] })
    );
    const { testList } = useLazyNewsTests(target, () =>
      findNewsTests({ clID: [clID.value] })
    );
    const domainList = computed(() => {
      let list = store.state.category.list.find(
        (items) => items.clID === clID.value
      );
      return list;
    });
    onUnmounted(() => {
      // 清除定时器
      if (intervalId) {
        clearInterval(intervalId);
      }
    });
    return { testList, target, list: result, NewsVideo, domainList };
  },
};
</script>

<style lang="less" scoped>
.news-list {
  height: 500px;
  //background: #f0e5e5;
  display: flex;
  justify-content: space-between;
  .left {
    width: 400px;
    height: 500px;
    display: flex;
    flex-direction: column;
    .top {
      width: 400px;
      height: 240px;
      .top-carousel {
        display: inline-block;
        width: 360px;
        height: 130px;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 15px;
        border-radius: 5px;

        .bottom-carousel {
          display: flex;
          flex-direction: column;
          margin-top: 10px;
          height: 80px;
          width: 360px;

          .carousel-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            width: 360px;
          }
          .carousel-bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            width: 360px;
          }
        }
      }
    }

    .bottom {
      width: 400px;
      height: 250px;
      .recommend {
        display: flex;
        height: 50px;
        align-items: center;
        justify-content: space-between;
        background: rgb(244, 244, 244);
        h3 {
          margin-left: 10px;
        }
        .more {
          a {
            display: flex;
            align-items: center;
            margin-right: 10px;
            color: #999;
            &:hover {
              color: @shColor;
            }
          }
        }
      }
      .recommend-cate {
        display: flex;
        height: 210px;
        justify-content: space-between;
        .cate-left {
          width: 195px;
          position: relative;
          border: 1px solid rgb(244, 244, 244);
          a {
            width: 195px;
            margin-right: 5px;

            img {
              width: 195px;
              height: 120px;
            }
            i {
              display: inline-block;
              position: absolute;
              top: 0px;
              left: 0px;
              width: 38px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              color: #fff;
              font-size: 12px;
              background: @shColor;
            }
            span {
              margin: 5px 5px 5px 5px;
              &:hover {
                color: @shColor;
              }
            }
          }
          .cate-desc {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            h3 {
              width: 80px;
              margin-left: 10px;
              color: #fd7502;
            }
            a {
              display: inline-block;
              height: 22px;
              margin-bottom: 5px;
              width: 80px;
            }
          }
        }
        .cate-right {
          width: 195px;
          position: relative;
          border: 1px solid rgb(244, 244, 244);
          a {
            width: 195px;
            margin-right: 5px;

            img {
              width: 195px;
              height: 120px;
            }
            i {
              display: inline-block;
              position: absolute;
              top: 0px;
              left: 0px;
              width: 38px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              color: #fff;
              font-size: 12px;
              background: @shColor;
            }
            span {
              margin: 5px 5px 5px 5px;
              &:hover {
                color: @shColor;
              }
            }
          }
          .cate-desc {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            h3 {
              width: 80px;
              margin-left: 10px;
              color: #fd7502;
            }
            a {
              display: inline-block;
              width: 80px;
            }
          }
        }
      }
    }
  }
  .middle {
    margin-top: 15px;
    width: 400px;
    overflow: hidden;
    border: 1px solid rgb(244, 244, 244);
  }
  .right {
    margin-top: 15px;
    width: 400px;

    .notes {
    }
  }
}
</style>
